import type { ToasterProps } from "sonner";
import { Toaster as Sonner } from "sonner";

import { ErrorIcon, InfoIcon, SpinnerIcon, SuccessIcon, WarningIcon } from "@/components/appIcons";
import { sonnerStyle } from "@/components/ui/sonner-style";
import { sonnerToastOptions } from "@/components/ui/sonner-toast-options";
import { useIsMobile } from "@/hooks/use-media-query";

const Toaster = ({
  className,
  position,
  style,
  toastOptions,
  visibleToasts,
  ...props
}: ToasterProps) => {
  const isMobile = useIsMobile();

  return (
    <Sonner
      {...props}
      theme="dark"
      className={["toaster group", className].filter(Boolean).join(" ")}
      position={isMobile ? "top-center" : position}
      visibleToasts={isMobile ? 1 : visibleToasts}
      icons={{
        success: <SuccessIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <WarningIcon className="size-4" />,
        error: <ErrorIcon className="size-4" />,
        loading: <SpinnerIcon className="size-4 animate-spin" />,
      }}
      style={sonnerStyle(style, isMobile)}
      toastOptions={sonnerToastOptions(toastOptions, isMobile)}
    />
  );
};

export { Toaster };
